'use client';

import { Popover as PopoverPrimitive } from 'radix-ui';
import * as React from 'react';

import { cn } from '@/lib/cn';

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverAnchor = PopoverPrimitive.Anchor;

const PopoverArrow = PopoverPrimitive.Arrow;

const PortalWrapper = ({
  children,
  renderWithPortal,
}: React.PropsWithChildren<{ renderWithPortal: boolean }>) => {
  return renderWithPortal ? (
    <PopoverPrimitive.Portal>{children}</PopoverPrimitive.Portal>
  ) : (
    children
  );
};

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    renderWithPortal?: boolean;
  }
>(
  (
    {
      className,
      align = 'center',
      sideOffset = 4,
      renderWithPortal = true,
      ...props
    },
    ref
  ) => {
    return (
      <PortalWrapper renderWithPortal={renderWithPortal}>
        <PopoverPrimitive.Content
          ref={ref}
          align={align}
          sideOffset={sideOffset}
          className={cn(
            'z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-hidden data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95',
            className
          )}
          {...props}
        />
      </PortalWrapper>
    );
  }
);
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverContent, PopoverTrigger, PopoverAnchor, PopoverArrow };
